import React, { useContext } from "react";
import { SDLCMetadata, SDLCMetadataTypeGuards, } from "@sscs/types";
import { REPORT_PAGES_ROUTES } from "../../constants";
import { threatTypeFiltered } from "../../store/malwareSlice";
import { policyStateFiltered } from "../../store/policiesSlice";
import { severityFiltered, tagFiltered } from "../../store/vulnerabilitySlice";
import { SummaryCards } from "../../ui";
import { getFinalRisk } from "../../utils";
import { LinkToReportTab } from "../common";
import { ReportContext } from "../context";
import { useReportDispatch, useRiskAssessmentClick } from "../hooks";
const Cards = ({ summary }) => {
    var _a;
    const dispatch = useReportDispatch();
    const { diffId, reportId, selectedCheck } = useContext(ReportContext);
    const scanReport = summary.checks_report.report.scans[selectedCheck];
    const finalRisk = getFinalRisk(scanReport === null || scanReport === void 0 ? void 0 : scanReport.assessments);
    const riskCategory = finalRisk
        ? finalRisk[0]
        : undefined;
    const { linkTarget, handleRiskCountClick } = useRiskAssessmentClick({
        reportId,
        diffId,
        riskCategory,
        selectedCheck,
        violations: (_a = finalRisk === null || finalRisk === void 0 ? void 0 : finalRisk[1].violations) !== null && _a !== void 0 ? _a : [],
    });
    if (!summary || !scanReport)
        return null;
    return (React.createElement(SummaryCards.Container, null,
        React.createElement(SummaryCards.FinalRisk, { risk: scanReport.assessments, footerWrapper: (children) => (React.createElement(LinkToReportTab, { id: "count", to: linkTarget, color: "link", onClick: () => handleRiskCountClick() }, children)) }),
        React.createElement(SummaryCards.PolicyViolations, { detectedCount: scanReport.statistics.quality.issues[SDLCMetadata.policy_metrics_t.issues_total_k], checksCount: summary.counters.total_policies -
                Object.keys(scanReport.disabled).length, footerWrapper: (children) => (React.createElement(LinkToReportTab, { id: "evaluated-policies-count", to: REPORT_PAGES_ROUTES.POLICIES_ROUTE, color: "link", onClick: () => dispatch(policyStateFiltered("enabled")) }, children)) }),
        React.createElement(SummaryCards.Vulnerabilities, { statistics: scanReport.statistics.vulnerabilities, footerWrapper: (verdict, children) => (React.createElement(LinkToReportTab, { id: "total-vulnerabilities", onClick: () => {
                    if (verdict) {
                        if (SDLCMetadataTypeGuards.stringIsExploitPresence(verdict)) {
                            dispatch(tagFiltered([verdict]));
                        }
                        else {
                            dispatch(severityFiltered(verdict));
                        }
                    }
                }, to: REPORT_PAGES_ROUTES.VULNERABILITIES_ROUTE, color: "link" }, children)) }),
        React.createElement(SummaryCards.ThreatsDetected, { detections: summary.analysis_summary.detections, footerWrapper: (threatType, children) => (React.createElement(LinkToReportTab, { id: "total-malware", onClick: () => dispatch(threatTypeFiltered({
                    threat_type: threatType,
                    hide_triaged: true,
                })), to: REPORT_PAGES_ROUTES.MALWARE_ROUTE, color: "link" }, children)) })));
};
export default Cards;
//# sourceMappingURL=Cards.js.map